import React, { useContext, useState, createContext, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import ToggleButton from 'react-bootstrap/ToggleButton';
import InputGroup from 'react-bootstrap/InputGroup';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import { Route, Routes, BrowserRouter as Router, useNavigate, Navigate } from 'react-router-dom';
import { Dispatch, SetStateAction } from "react";

import Image from 'react-bootstrap/Image';
import logoBulldog from './files/bulldog_orange.png'
import logotransportpreis from './files/preisberechnung1.png'
import ruedingerlogopfeil from './files/ruedingerlogopfeil.png'
import zusatzleistungen from './files/zusatzleistungen.png'
import abmessungen from './files/abmessungen.png'
import gesamtpreis from './files/gesamtkosten.png'
import buchungsbestaetigung from './files/buchungsbestaetigung.png'
import adressdatenVersender from './files/adressdatenVersender.png'
import adressdatenEmpfaenger from './files/adressdatenEmpfaenger.png'
import bearbeiten from './files/bearbeiten.png'
//import back from './files/back.png'

import { libBerechneDatumVolljaehrigAbIsoStr, libInEuroAnzeigen} from '../lib/libHelpers';
import { Auftrag, AuftragAdrKeys, auftragDefaults, pruefeAdresse, REGEX_PLZ, istAdresseGleichFrachtzahler, auftragAbsendenCoponent} from '../classes/Auftrag'
import { /*Preisanfrage,*/ PreisanfrageRueckgabe, holePreisHttp, holePreisComponent } from '../classes/Preisanfrage';
import { webserviceEnvironmentMap, WebserviceEnvironment, Environment } from '../classes/environment';
import AlertDismissible, { AlertDismissibleProps} from './AlertDimissible';
import { Mass, MasseKeys } from '../classes/Masse';
import { isDisabled } from '@testing-library/user-event/dist/utils';


type StepProps = {
  auftrag: Auftrag;
  setAuftrag: Function;
}

const StepPropsDefault : StepProps = {
  auftrag: auftragDefaults,
  setAuftrag: () => {},
}

const environmentKey = Environment.PROD;
//const environmentKey = Environment.DEVTEST;
//const environmentKey = Environment.DUMMY;
const webserviceEnvironment = webserviceEnvironmentMap[environmentKey];


//const AuftragContext = createContext<StepContext>({activeStepIndex: 0, auftrag: {warenwert: "", key: 4, teststr: "sdfsd"}});
const AuftragContext = createContext<StepProps>(StepPropsDefault);

//Navigator
export const Navigator = () => {
  const [auftrag, setAuftrag] = useState<Auftrag>(auftragDefaults);



  return(
    <Router>
      <AuftragContext.Provider value={{auftrag: auftrag, setAuftrag: setAuftrag}}>
        <Container fluid="md" className="h-100">
          <div style={{position: "fixed"}}>{ ![Environment.PROD].includes(environmentKey) && JSON.stringify(auftrag)}</div>
          <Row className="h-100 justify-content-center align-items-center">
          {/*{stepComponents[activeStepIndex]}*/}
            <Routes>
              <Route path='/' Component={() => <Navigate to="/steps/1" replace/> } />
              <Route path="/steps/1" Component={StepPlzLadeEntladestelle}></Route> {/*IDX 0*/}
              <Route path="/steps/2" element={auftrag.letzterPreis != null ? <StepTransportpreis/> : <Navigate to="/steps/1"/>}></Route> {/*IDX 1*/}
              <Route path="/steps/2-1" element={auftrag.letzterPreis != null ? <StepMasseEingeben/> : <Navigate to="/steps/1"/>}></Route> {/*IDX 2*/}
              <Route path="/steps/2-2" element={auftrag.letzterPreis != null ? <StepTransportpreisNeu/> : <Navigate to="/steps/1"/>}></Route> {/*IDX 3*/}
              <Route path="/steps/3" element={auftrag.letzterPreis != null ? <StepZusatzleistungen/> : <Navigate to="/steps/1"/>}></Route> {/*IDX 4*/}
              <Route path="/steps/4" element={auftrag.letzterPreis != null ? <StepTransportpreisGesamt/> : <Navigate to="/steps/1"/>}></Route> {/*IDX 5*/}
              <Route path="/steps/5" element={auftrag.letzterPreis != null ? <StepFrachtzahlerEingeben/> : <Navigate to="/steps/1"/>}></Route> {/*IDX 6*/}
              <Route path="/steps/6" element={auftrag.letzterPreis != null ? <StepVersenderEingeben/> : <Navigate to="/steps/1"/>}></Route> {/*IDX 7*/}
              <Route path="/steps/7" element={auftrag.letzterPreis != null ? <StepEmpfaengerEingeben/> : <Navigate to="/steps/1"/>}></Route> {/*IDX 8*/}
              <Route path="/steps/8" element={auftrag.letzterPreis != null ? <StepSendungsdatenEingeben/> : <Navigate to="/steps/1"/>}></Route> {/*IDX 9*/}
              <Route path="/steps/9" element={auftrag.letzterPreis != null ? <StepBestaetigung/> : <Navigate to="/steps/1"/>}></Route> {/*IDX 10*/}
              <Route path="/steps/10" element={auftrag.letzterPreis != null ? <StepBezahlung/> : <Navigate to="/steps/1"/>}></Route> {/*IDX 11*/}
              <Route path="/steps/11" element={<StepFrachtzahlerEingeben nextStep="/steps/9"/>}></Route> {/*IDX 12*/}
              <Route path="/steps/12" element={<StepVersenderEingeben nextStep="/steps/9"/>}></Route> {/*IDX 13*/}
              <Route path="/steps/13" element={<StepEmpfaengerEingeben nextStep="/steps/9"/>}></Route> {/*IDX 14*/}
            </Routes>
          </Row>
        </Container>
      </AuftragContext.Provider>
    </Router>
  )
};

//Grundeinstellung für alle Überschriften
const HeaderStep = (props: {text : string[]}) => {
  return(
    <>
    {props.text.map( (s, i, r) => ( <h1 key={i} className={"text-center" + (i == r.length-1 ? " mb-4" : "") }>{s}</h1>) )}
    </>
  )
}




//Grundeinstellungen für alle Grafiken (Mittig, 25% der tatsächlichen Größe, passt sich automatisch an Formatierung an)
const ImageStepCol = (props: {img : string, colCount ?: number}) => {
  return(
    <Col xs={props.colCount ?? 10} className="text-center mx-auto mb-2 mb-lg-4 mt-lg-1 mt-5">
      <Image src={props.img} className="w-25"/>
    </Col>
  )
}


//Grundeinstellungen für Adressdaten
const EingabeAdressdaten = (props : {disabled : boolean, ustidVerstecken: boolean, gebdatumVerstecken: boolean, plzDisabled: boolean, auftrKey: AuftragAdrKeys}) => {
  const {auftrag, setAuftrag} = useContext(AuftragContext);
  const regexUstIdEingabe = new RegExp("^(|D|DE|DE\\d{0,9})$");
  const regexTelNrEingabe = new RegExp("^(|[0+]|[0+][0-9\\-/ ]*)$");
  const regexEmailEingabe = new RegExp("^(|[^@\\s]*|[^@\\s]*@|[^@\\s]*@[^@\\s]*)$");
  const key = props.auftrKey;

  const [hatFehlerPlz, setHatFehlerPlz] = useState(false);


  return(
    <>
      <Row>
        <Col sm="4">
          <Form.Control disabled={props.disabled} value={auftrag[key].firma ?? ''} className="mt-3" size="lg" placeholder="Firma (falls vorhanden)"
            onChange={ (event) => {const val = event.target.value; setAuftrag( {  ...auftrag, [key]: { ...auftrag[key], firma: val == "" ? null : val }  } ); } }/>
        </Col>
        <Col sm="4">
          <Form.Control disabled={props.disabled} value={auftrag[key].name ?? ''} className="mt-3" size="lg" placeholder="Vorname, Nachname"
            onChange={ (event) => {const val = event.target.value; setAuftrag( {  ...auftrag, [key]: { ...auftrag[key], name: val == "" ? null : val }  } ); console.log(val == "" ? "Bitte Name ausfüllen!" : "");} }/>
        </Col>
        <Col sm="4" hidden={props.ustidVerstecken}>
          <Form.Control disabled={props.disabled} value={auftrag[key].ustid ?? ''} className="mt-3" size="lg" placeholder="Ust-ID-Nr."
            onChange={ (event) => {const val = event.target.value.toUpperCase(); regexUstIdEingabe.test(val) && setAuftrag( {  ...auftrag, [key]: { ...auftrag[key], ustid: val == "" ? null : val }  } )} }/>
        </Col>
      </Row>
      <Row>
        <Col sm="4">
          <Form.Control disabled={props.disabled} value={auftrag[key].str ?? ''} className="mt-3" size="lg" placeholder="Straße, Hausnummer"
            onChange={ (event) => {const val = event.target.value; setAuftrag( {  ...auftrag, [key]: { ...auftrag[key], str: val == "" ? null : val }  } );} }/>
        </Col>
        <Col sm="4">
          {/*<Form.Control disabled={props.disabled} value={auftrag[key].plz ?? ''} className="mt-3" size="lg" placeholder="PLZ" />*/}
          <EingabePlz auftrKey={key} beschriftung="PLZ" setStateFehler={setHatFehlerPlz} isDisabled={props.disabled || props.plzDisabled}/>
        </Col>
        <Col sm="4">
          <Form.Control disabled={props.disabled} value={auftrag[key].ort ?? ''} className="mt-3" size="lg" placeholder="Ort"
            onChange={ (event) => {const val = event.target.value; setAuftrag( {  ...auftrag, [key]: { ...auftrag[key], ort: val == "" ? null : val }  } );} }/>
        </Col>
      </Row>
      <Row>
        <Col sm="4">
          <Form.Control disabled={props.disabled} value={auftrag[key].tel ?? ''} className="mt-3" size="lg" placeholder="Telefon- oder Handynummer"
            onChange={ (event) => {const val = event.target.value; regexTelNrEingabe.test(val) && setAuftrag( {  ...auftrag, [key]: { ...auftrag[key], tel: val == "" ? null : val }  } );} }/>
        </Col>
        <Col sm="4">
          <Form.Control disabled={props.disabled} value={auftrag[key].email ?? ''} className="mt-3" size="lg" placeholder="E-Mail-Adresse"
            onChange={ (event) => {const val = event.target.value.toLowerCase(); regexEmailEingabe.test(val) && setAuftrag( {  ...auftrag, [key]: { ...auftrag[key], email: val == "" ? null : val }  } );} }/>
        </Col>
        <Col sm="4" hidden={props.gebdatumVerstecken}>
          <Form.Control disabled={props.disabled} value={auftrag[key].gebDat ?? ''} className="mt-3" size="lg" placeholder="Geburtsdatum" type='date'
            max={ libBerechneDatumVolljaehrigAbIsoStr() }
            onChange={ (event) => {const val = event.target.value; setAuftrag( {  ...auftrag, [key]: { ...auftrag[key], gebDat: val == "" ? null : val }  } )} }/>
        </Col>
      </Row>
    </>
  )
}



//Grundeinstellung Button "Abbrechen"
const ButtonAbbrechen = () => {
  const [show, setShow] = useState(false);
  const {auftrag, setAuftrag} = useContext(AuftragContext);
  const navigate = useNavigate();

  const abbrechenGedrueckt = () => {
    setShow(true);
  }

  const dialogBeenden = () => setShow(false);
  const abbrechen = () => {
    setShow(false);
    setAuftrag(auftragDefaults);
    navigate("/steps/1");
  }

  return(
    <>
    <Button variant="secondary" size="lg" className="w-100" onClick={abbrechenGedrueckt}>
      Abbrechen
    </Button>
    <Modal show={show} onHide={dialogBeenden}>
      <Modal.Header closeButton>
        <Modal.Title>Wirklich abbrechen?</Modal.Title>
      </Modal.Header>
      <Modal.Body>Wenn Sie die Eingabe abbrechen, gehen die bisher eingetragenen Angaben verloren. Sind Sie sich sicher?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={abbrechen}>
          Eingabe abbrechen
        </Button>
        <Button variant="primary" onClick={dialogBeenden}>
          Weitermachen
        </Button>
      </Modal.Footer>
    </Modal>
    </>

  )
}


//Grundeinstellung Button "Transportversicherung überspringen"
const ButtonTransportversicherung = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const {auftrag, setAuftrag} = useContext(AuftragContext);
  const ueberspringenGedrueckt = () => {
    setShow(true);
  }

  const dialogBeenden = () => setShow(false);
  const ueberspringen = () => {
    setShow(false);
    setAuftrag({...auftrag, warenwert: null})
    navigate("/steps/5");
  }
  return(
    <>
    <Button variant="secondary" size="lg" className="w-100" onClick={ueberspringenGedrueckt}>
      Überspringen
    </Button>
    <Modal show={show} onHide={dialogBeenden}>
      <Modal.Header closeButton>
        <Modal.Title>Wirklich Überspringen?</Modal.Title>
      </Modal.Header>
      <Modal.Body>Für <strong>Privatkunden</strong> ist eine Transportversicherung <strong>verpflichtend</strong>. Sind Sie Privatkunde?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={ueberspringen}>
          Nein, ich bin Gewerbekunde
        </Button>
        <Button variant="primary" onClick={dialogBeenden}>
          Ja, ich bin Privatkunde
        </Button>
      </Modal.Footer>
    </Modal>
    </>
  )
}

//Eingabefeld für PLZ
const EingabePlz = (props : {beschriftung: string, auftrKey: AuftragAdrKeys, isDisabled : boolean, setStateFehler: Dispatch<SetStateAction<boolean>>}) => {
  const regexPlzEingabe = new RegExp("^\\d{0,5}$");
  const {auftrag, setAuftrag} = useContext(AuftragContext);

  const key: AuftragAdrKeys = props.auftrKey;

  useEffect(() => {
    check();
  });

  const check = () => {
    let hatFehler = false;
    if(!REGEX_PLZ.test(auftrag[key].plz ?? "")){
      hatFehler = true;
    }
    props.setStateFehler(hatFehler);
    //console.log(hatFehler);
  }

  const eingabeVerarbeiten = (event: React.ChangeEvent<HTMLInputElement>) => {
    {
      const val = event.target.value;
      if(regexPlzEingabe.test(val)) {
        setAuftrag( {  ...auftrag, [key]: { ...auftrag[key], plz: val == "" ? null : val }  } );
      }
      check();
    } 
  }

  return(
    <Form.Control className="mt-3" size="lg" placeholder={props.beschriftung} value={auftrag[key].plz ?? '' } disabled={props.isDisabled} onChange={eingabeVerarbeiten}/>
  );
}

//Eingabefeld für Mass
const EingabeMass = (props : {beschriftung: string, max: number, masseKey: MasseKeys, disabled: boolean}) => {
  const regexMasseEingabe = new RegExp("^(|\\d+)$");
  const {auftrag, setAuftrag} = useContext(AuftragContext);

  const key: MasseKeys = props.masseKey;

 // const eingabeVerarbeiten = (event: React.ChangeEvent<HTMLInputElement>) => {
 //   const val = event.target.value;
 //   if (regexPlzEingabe.test(val)) {
 //     setAuftrag( {  ...auftrag, [key]: { ...auftrag[key], plz: val == "" ? null : val }  } );
 //   }
 // }

  return(
    <Form.Control disabled={props.disabled} type="number" className="mt-3" size="lg" placeholder={props.beschriftung + " in cm, max. " + props.max} value={auftrag.sendung?.masse?.[key] ?? ''}
      onChange={ (event) => {const val = event.target.value; regexMasseEingabe.test(val) && (val == "" || parseInt(val) <= props.max) && setAuftrag({...auftrag, sendung: {...auftrag.sendung, masse: {...auftrag.sendung?.masse, [props.masseKey]:val == "" ? null : val}}})} }/>
  );
}


//1.Schritt: PLZ Lade/Entladestelle: Idx 0
const StepPlzLadeEntladestelle = () => {
  //const [istBulldogFahrtuechtig, setIstBulldogFahrtuechtig] = useState(true);
  const {auftrag, setAuftrag} = useContext(AuftragContext);
  const navigate = useNavigate();
  const [fehlerAnzeigen, setFehlerAnzeigen] = useState(false);
  const [fehlertext, setFehlertext] = useState(<></>);
  
  const [hatFehlerPlzLad, setHatFehlerPlzLad] = useState(true);
  const [hatFehlerPlzElad, setHatFehlerPlzElad] = useState(true);

  const preisKalkulieren = async () => {
    if(hatFehlerPlzLad){
      setFehlertext(<>Bitte eine gültige <strong>Lade-PLZ</strong> angeben!</>);
      setFehlerAnzeigen(true);
    } else if(hatFehlerPlzElad){
      setFehlertext(<>Bitte eine gültige <strong>Entlade-PLZ</strong> angeben!</>);
      setFehlerAnzeigen(true);
    } else {
        try {
          setAuftrag(await holePreisComponent(auftrag, webserviceEnvironment));
          navigate("/steps/2");
        } catch (error) {
          if (typeof error == "string") {
            setFehlertext(<>{error}</>);
          } else {
            console.error(error);
            setFehlertext(<>Fehler beim Abrufen des Preises!</>);
          }
          setFehlerAnzeigen(true);
        }
    }
    
  }
  return (
    <div>
      <AlertDismissible header="Fehler!" msgtext={fehlertext} show={fehlerAnzeigen} setShow={setFehlerAnzeigen}/>
      <Row>
        <ImageStepCol img={ruedingerlogopfeil} colCount={8}/>
      </Row>
      <Row className='mt-3'>
        <Col>
          <HeaderStep text={["Bulldog-Transport gesucht?", "Hier ist die Lösung!"]}/>
        </Col>
      </Row>
      <Row>
        <ImageStepCol img={logoBulldog}/>
      </Row>
      <Row className='mt-3'>
        <Col className="text-center fs-4 mb-md-2">
            Für die Preiskalkulation benötigen wir die <strong>korrekte</strong> Postleitzahl der Lade- und Entladestelle.<br/>
        </Col>
      </Row>
      <Row>
        <Col className="text-center fs-9 mb-md-3">
            Diese Eingabe kann im Nachgang nicht mehr geändert werden.
        </Col>
      </Row>
      <Form>
        <Row>
          <Col sm="6">
            <EingabePlz beschriftung="PLZ Ladestelle" auftrKey="lad" setStateFehler={setHatFehlerPlzLad} isDisabled={false}/>
          </Col>
          <Col sm="6">
            <EingabePlz beschriftung="PLZ Entladestelle" auftrKey="elad" setStateFehler={setHatFehlerPlzElad} isDisabled={false}/>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col md={{span: 12, offset: 0}}>
            <Form.Check checked={auftrag.istFahrtuechtig} onChange={(e) => setAuftrag({...auftrag, istFahrtuechtig : e.currentTarget.checked}) } className="fs-4" type="switch" id="custom-switch" label="Bulldog ist fahrtüchtig"/>
        </Col>
      </Row>
        <Row className="d-grid gap-2 mt- mt-4">
          <Button variant="primary" size="lg" onClick={preisKalkulieren}>
            Preis kalkulieren
          </Button>
        </Row>
      </Form>
    </div>
  );
}


//2. Schritt: Anzeige Transportpreis: Idx 1
const StepTransportpreis = () => {
  const {auftrag, setAuftrag} = useContext(AuftragContext);
  const navigate = useNavigate();

  const masseEingeben = () => {
    navigate("/steps/2-1");
  }
  const masseAkzeptieren = () => {
    setAuftrag({...auftrag, sendung: {...auftrag.sendung, masse: null}})
    navigate("/steps/3");
  }

  return (
    <div>

      <Row>
        <ImageStepCol img={logotransportpreis}/>
      </Row>
      <Row className='mt-5'>
        <Col>
          <HeaderStep text={["Ihr Transportpreis:"]}/>
        </Col>
      </Row>
      <Row>
        <Col className="text-center fs-1 fw-bold">
            {libInEuroAnzeigen(auftrag.letzterPreis?.gesamt?.wert ?? 0)}
        </Col>
      </Row>
      <Row>
        <Col className="text-center fs-6 mb-md-3">
            zuzüglich Mehrwertsteuer
        </Col>
      </Row>
      <Row className="mt-3">
        <Col className="text-center fs-4 mb-md-3">
        Für die Transportpreisberechnung sind wir von folgenden Maximalabmessungen (Länge, Breite, Höhe) ausgegangen:
            <div>400 cm x 240 cm x 300 cm</div>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col className="text-center fs-4 mb-md-4">
          <strong>Ist Ihr Bulldog größer?</strong>
        </Col>
      </Row>
      <Form>
        <Row>
        <Stack direction="horizontal" className="mt-1" gap={2}>
          <Button variant="primary" size="lg" className="col-6 col-md-3 offset-md-2" onClick={masseEingeben}>
            Ja
          </Button>
          <Button variant="primary" size="lg" className="col-6 col-md-3 offset-md-2" onClick={masseAkzeptieren}>
            Nein
          </Button>
        </Stack>
        </Row>
        <Row className="mt-3">
          <Col className="text-center fs-9 mb-md-3">
            <strong>Bitte beachten Sie:</strong> Bei der Transportabwicklung gehen wir von einer Laufzeit zwischen 1-2 Wochen aus. <br/>
             Den genauen Abhol- und Liefertermin stimmen wir mit Ihnen ab.
          </Col>
      </Row>
      </Form>

    </div>
  );
}

//Schritt 2.1 Maße eingeben: Idx 2
const StepMasseEingeben = () => {
  const [maxLaenge, maxBreite, maxHoehe] = [700, 240, 300];
  const {auftrag, setAuftrag} = useContext(AuftragContext);
  const [fehlerAnzeigen, setFehlerAnzeigen] = useState(false);
  const [fehlertext, setFehlertext] = useState(<></>);

  const navigate = useNavigate();

  const preisKalkulierenMasse = async () => {
    if(auftrag.sendung?.masse?.laenge == null || auftrag.sendung?.masse?.breite == null || auftrag.sendung?.masse?.hoehe == null){
      setFehlertext(<>Bitte gültige Maße eingeben!</>)
      setFehlerAnzeigen(true);
    } else {
        try {
          setAuftrag(await holePreisComponent(auftrag, webserviceEnvironment));
          navigate("/steps/2-2");
        } catch (error) {
          if (typeof error == "string") {
            setFehlertext(<>{error}</>);
          } else {
            console.error(error);
            setFehlertext(<>Fehler beim Abrufen des Preises!</>);
          }
          setFehlerAnzeigen(true);
        }
    }
  }

  return (
    <div>
      <AlertDismissible header="Fehler" msgtext={fehlertext} show={fehlerAnzeigen} setShow={setFehlerAnzeigen}/>
      <Row>
        <ImageStepCol img={abmessungen}/>
      </Row>
      <Row className='mt-5'>
        <Col>
          <HeaderStep text={["Sendungsdaten:"]}/>
        </Col>
      </Row>
      <Row>
        <Col className="text-center fs-4 mb-md-3">
            Bitte tragen Sie hier die <strong> genauen </strong> Abmessungen des Bulldogs ein:
        </Col>
      </Row>
      <Form>
        <Row>
          <Col sm="4">
            <EingabeMass beschriftung="Länge" max={maxLaenge} masseKey="laenge" disabled={false}/>
          </Col>
          <Col sm="4">
            <EingabeMass beschriftung="Breite" max={maxBreite} masseKey="breite" disabled={false}/>
          </Col>
          <Col sm="4">
            <EingabeMass beschriftung="Höhe" max={maxHoehe} masseKey="hoehe" disabled={false}/>
          </Col>
        </Row>
        <Row className="mt-3">
        <Col className="text-center fs-6 mb-md-3">
            Diese Angaben können im weiteren Verlauf nicht mehr geändert werden.
        </Col>
      </Row>
        <Row className="d-grid gap-2 mt- mt-3">
          <Button variant="primary" size="lg" onClick={preisKalkulierenMasse}>
            Angaben Bestätigen und weiter
          </Button>
        </Row>
      </Form>

    </div>
  );
}


//Schritt 2.2: Anzeige neuer Transportpreis + bestätigen: Idx 3
const StepTransportpreisNeu = () => {
  const {auftrag, setAuftrag} = useContext(AuftragContext);
  const navigate = useNavigate();
  const preisBestaetigen = () => {
    navigate("/steps/3");
  }

  return (
    <div>
      <Row>
        <ImageStepCol img={logotransportpreis}/>
      </Row>
      <Row className='mt-5'>
        <Col>
          <HeaderStep text={["Neuer Transportpreis:"]}/>
        </Col>
      </Row>
            <Row>
        <Col className="text-center fs-1 fw-bold">
            {libInEuroAnzeigen(auftrag.letzterPreis?.gesamt?.wert ?? 0)}
        </Col>
      </Row>
      <Row>
        <Col className="text-center fs-6 mb-md-3">
            zuzüglich Mehrwertsteuer
        </Col>
      </Row>
      <Row>
      </Row>
      <Form>
        <Row className="mt-2">
          <Col sm="6" className="mt-3">
          <Button variant="primary" size="lg" className="w-100" onClick={preisBestaetigen}>
            Transport beauftragen
          </Button>
          </Col>
          <Col sm="6" className="mt-3">
           {/* Abbrechen-Button */}
          <ButtonAbbrechen/>
          </Col>
        </Row>
      </Form>

    </div>
  );
}

//Schritt 3: Transportversicherung: Idx 4
const StepZusatzleistungen = () => {
  const regexWarenwertEingabe = new RegExp("^(|\\d+(|,\\d{0,2}))$");
/*  const [auftrag, setAuftrag] = useState(props.auftrag);
  useEffect(() => {
    props.setAuftrag(auftrag)
  }, [auftrag])
*/
  const [fehlerAnzeigen, setFehlerAnzeigen] = useState(false);
  const [fehlertext, setFehlertext] = useState(<></>);
  const {auftrag, setAuftrag} = useContext(AuftragContext);
  const navigate = useNavigate();

  const transportversicherungBuchen = async () => {
    if((auftrag.sendung?.warenwert ?? null) == null){
      setFehlertext(<>Für die Transportversicherung ist die Eingabe des Warenwertes nötig. Bitte geben Sie diesen ein.</>)
      setFehlerAnzeigen(true);
    } else {
        try {
          setAuftrag(await holePreisComponent(auftrag, webserviceEnvironment));
          navigate("/steps/4");
        } catch (error) {
          if (typeof error == "string") {
            setFehlertext(<>{error}</>);
          } else {
            console.error(error);
            setFehlertext(<>Fehler beim Abrufen des Preises!</>);
          }
          setFehlerAnzeigen(true);
        }
    }
  }

  return (
    <div>
      <AlertDismissible header="Fehler!" msgtext={fehlertext} show={fehlerAnzeigen} setShow={setFehlerAnzeigen}/>
      <Row>
        <ImageStepCol img={zusatzleistungen}/>
      </Row>
      <Row className='mt-5'>
        <Col>
          <HeaderStep text={["Transportversicherung"]}/>
        </Col>
      </Row>
      <Row>
        <Col className="text-center fs-4"> Sie möchten eine Transportversicherung dazubuchen? <br/>
        Tragen Sie hier den Warenwert (Kaufpreis) ein:
        </Col>
      </Row>
      <Row>
        <Col sm="12">
            <Form.Control className="mt-3" size="lg" placeholder="Warenwert in €" value={auftrag.sendung?.warenwert ?? ''}
              onChange={ (event) => { const val = event.target.value; regexWarenwertEingabe.test(event.target.value)
                && setAuftrag({...auftrag, sendung: {...auftrag.sendung, warenwert: val == "" ? null : val}})} }/>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col className="text-center fs-9 mb-md-3">
            Die Höhe der Transportversicherung beträgt 1 ‰ des Warenwerts, mindestens jedoch 5,- € <br/>
            Bei Gebrauchtfahrzeugen müssen vor dem Transport vorhandene Mängel (Lackbeschädigungen, Kratzer, Dellen, etc.) gut dokumentiert werden, ansonsten greift die Transportversicherung nicht.
        </Col>
      </Row>
      <Form>
        <Row className="mt-2">
        <Col sm="6" className="mt-3">
          <Button variant="primary" size="lg" className="w-100" onClick={transportversicherungBuchen}>
            Transportversicherung buchen
          </Button>
        </Col>
        <Col sm="6" className="mt-3">
        {/* Überspringen-Button */}
          <ButtonTransportversicherung/>
        </Col>
        </Row>
      </Form>
    </div>
  );
}
const AuswahlZusatzleistung = (props: {id : string; bez : string; kosten: string}) => {
  const [ausgewaehlt, setAusgewaehlt] = useState(false);

  return(
    <ToggleButton className="w-100 h-100 btn" id={props.id} type="checkbox" variant="light" checked={ausgewaehlt} onChange={(e) => setAusgewaehlt(e.currentTarget.checked)} value="1">
      <span className="fw-bold">{props.bez}</span><br/>
      {props.kosten}
    </ToggleButton>
  );
}

//Schritt 4: Anzeige Gesamtpreis + buchen: Idx 5
const StepTransportpreisGesamt = () => {
  const {auftrag, setAuftrag} = useContext(AuftragContext);
  const navigate = useNavigate();

  const preisBestaetigen = () => {
    navigate("/steps/5");
  }

  return (
    <div>
      <Row>
        <ImageStepCol img={gesamtpreis}/>
      </Row>
      <Row>
        <Col className="mt-5">
          <HeaderStep text={["Gesamtkosten:"]}/>
        </Col>
      </Row>
      <Row>
        <Col className="text-center fs-1 fw-bold">
            {libInEuroAnzeigen(auftrag.letzterPreis?.gesamt?.wert ?? 0)}
        </Col>
      </Row>
      <Row>
        <Col className="text-center fs-6 mb-md-3">
            zuzüglich Mehrwertsteuer
        </Col>
      </Row>
      <Row>
        <Col className="text-center fs-8">
            Der Gesamtpreis setzt sich aus den Transportkosten ({libInEuroAnzeigen(auftrag.letzterPreis?.transport?.wert ?? 0)})
            und ggf. den Kosten für die Transportversicherung ({libInEuroAnzeigen(auftrag.letzterPreis?.tv?.wert ?? 0)}) zusammen.
        </Col>
      </Row>
      <Form>
        <Row className="mt-2">
        {/* Bestätigungs-Button */}
        <Col sm="6" className="mt-3">
          <Button variant="primary" size="lg" className="w-100" onClick={preisBestaetigen}>
            Transport beauftragen
          </Button>
        </Col>
        <Col sm="6" className="mt-3">
        {/* Abbrechen-Button */}
        <ButtonAbbrechen/>
        </Col>
        </Row> 
      </Form>

    </div>
  );
}



//Schritt 5 Eingabe Frachtzahler: Idx 6
const StepFrachtzahlerEingeben = (props: {nextStep ?: string}) => {
  const {auftrag, setAuftrag} = useContext(AuftragContext);
  const navigate = useNavigate();
  const [fehlerAnzeigen, setFehlerAnzeigen] = useState(false);
  const [fehlerText, setFehlerText] = useState("");

  const weiter = () => {
    let fehler = pruefeAdresse(auftrag, "fz");
    if( fehler != null) {
        setFehlerText(fehler);
        setFehlerAnzeigen(true);
    } else {
      navigate(props.nextStep ?? "/steps/6");
    }
  }

  return (
    <div>
      <AlertDismissible header="Eingabefehler" msgtext={<>{fehlerText}</>} show={fehlerAnzeigen} setShow={setFehlerAnzeigen}/>
      <Row>
        <ImageStepCol img={gesamtpreis}/>
      </Row>   
      <Row className="mt-5">
        <Col>
          <HeaderStep text={["Frachtzahler"]}/>
        </Col>
      </Row>
      <Row>
        <Col className="text-center fs-4 mb-md-3">
            Bitte tragen Sie hier die Daten des Rechnungsempfängers ein:
        </Col>
      </Row>
      <Form>
        <EingabeAdressdaten disabled={false} ustidVerstecken={false} gebdatumVerstecken={false} auftrKey="fz" plzDisabled={false}/>
        <Row className="mt-2">
        <Col sm="6" className="mt-3">
          <Button variant="primary" size="lg" className="w-100" onClick={weiter}>
            Bestätigen und weiter
          </Button>
        </Col>
        <Col sm="6" className="mt-3">
        {/* Abbrechen-Button */}
        {props.nextStep == null ? <ButtonAbbrechen/> : <></>}
        </Col>
        </Row>
      </Form>

    </div>
  );
}


//Schritt 6 Eingabe Versender: Idx 7
const StepVersenderEingeben = (props: {nextStep ?: string}) => {
  const {auftrag, setAuftrag} = useContext(AuftragContext);
  const [istVersenderFrachtzahler, setIstVersenderFrachtzahler] = useState(auftrag.fz.plz == auftrag.lad.plz);
  const navigate = useNavigate();
  const [fehlerAnzeigen, setFehlerAnzeigen] = useState(false);
  const [fehlerText, setFehlerText] = useState("");

  const weiter = () => {
    let fehler = pruefeAdresse(auftrag, "lad");
    if( fehler != null) {
        setFehlerText(fehler);
        setFehlerAnzeigen(true);
    } else {
      navigate(props.nextStep ?? "/steps/7");
    }
  }

  const toggleFz = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.currentTarget.checked) {
      !istAdresseGleichFrachtzahler(auftrag.fz, auftrag.elad) && auftrag.fz.plz == auftrag.lad.plz && setAuftrag({...auftrag, lad: auftrag.fz});
    } else {
      setAuftrag({...auftrag, lad: {plz: auftrag.fz.plz}});
    }
  }

  return (
    <div>
      <AlertDismissible header="Eingabefehler" msgtext={<>{fehlerText}</>} show={fehlerAnzeigen} setShow={setFehlerAnzeigen}/>
      <Row>
          <ImageStepCol img={adressdatenVersender} colCount={8}/>
      </Row>    
      <Row className="mt-5">
        <Col>
          <HeaderStep text={["Adressdaten"]}/>
        </Col>
      </Row>
      <Row>
        <Col className="text-center fs-4 mb-md-3">
            Wo soll der Bulldog abgeholt werden? <br/>
            Bitte tragen Sie hier die Adressdaten des Versenders ein:
        </Col>
      </Row>
      <Form>
        <Row className="mt-3">
          <Col md={{span: 12, offset: 0}}>
          <Form.Check checked={istAdresseGleichFrachtzahler(auftrag.fz, auftrag.lad)} onChange={toggleFz} className="fs-4" type="switch" id="custom-switch" label="Versender = Frachtzahler"/>
          </Col>
        </Row>
        <EingabeAdressdaten disabled={istAdresseGleichFrachtzahler(auftrag.fz, auftrag.lad)} ustidVerstecken={true} gebdatumVerstecken={true} auftrKey="lad" plzDisabled={true}/>
        <Row className="mt-2">
        <Col sm="6" className="mt-3">
          <Button variant="primary" size="lg" className="w-100" onClick={weiter}>
            Bestätigen und weiter
          </Button>
        </Col>
        <Col sm="6" className="mt-3">
        {/* Abbrechen-Button */}
        {props.nextStep == null ? <ButtonAbbrechen/> : <></>}
        </Col>
        </Row>
      </Form>

    </div>
  );
}

//Schritt 7 Eingabe Empfänger: Idx 8
const StepEmpfaengerEingeben = (props: {nextStep ?: string}) => {
  const {auftrag, setAuftrag} = useContext(AuftragContext);
  const [istEmpfaengerFrachtzahler, setIstEmpfaengerFrachtzahler] = useState(true);
  const navigate = useNavigate();
  const [fehlerAnzeigen, setFehlerAnzeigen] = useState(false);
  const [fehlerText, setFehlerText] = useState("");

  const weiter = () => {
    let fehler = pruefeAdresse(auftrag, "elad");
    if( fehler != null) {
        setFehlerText(fehler);
        setFehlerAnzeigen(true);
    } else {
      navigate(props.nextStep ?? "/steps/8");
    }
  }

  const toggleFz = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.currentTarget.checked) {
      
      !istAdresseGleichFrachtzahler(auftrag.fz, auftrag.lad) && auftrag.fz.plz == auftrag.elad.plz && setAuftrag({...auftrag, elad: auftrag.fz});
    } else {
      setAuftrag({...auftrag, elad: {plz: auftrag.fz.plz}});
    }
  }

  return (
    <div>
      <AlertDismissible header="Eingabefehler" msgtext={<>{fehlerText}</>} show={fehlerAnzeigen} setShow={setFehlerAnzeigen}/>
      <Row>
          <ImageStepCol img={adressdatenEmpfaenger} colCount={8}/>
      </Row>      
      <Row className="mt-5">
        <Col>
          <HeaderStep text={["Adressdaten"]}/>
        </Col>
      </Row>
      <Row>
        <Col className="text-center fs-4 mb-md-3">
        Wohin soll der Bulldog transportiert werden? <br/>
        Bitte tragen Sie hier die Adressdaten des Empfängers ein:
        </Col>
      </Row>
      <Form>
        <Row>
          <Col md={{span: 12, offset: 0}}>
          <Form.Check checked={istAdresseGleichFrachtzahler(auftrag.fz, auftrag.elad)} onChange={toggleFz} className="fs-4" type="switch" id="custom-switch" label="Empfänger = Frachtzahler"/>
          </Col>
        </Row>
        <EingabeAdressdaten disabled={istAdresseGleichFrachtzahler(auftrag.fz, auftrag.elad)} ustidVerstecken={true} gebdatumVerstecken={true} auftrKey="elad" plzDisabled={true}/>
        <Row className="mt-2">
        <Col sm="6" className="mt-3">
          <Button variant="primary" size="lg" className="w-100" onClick={weiter}>
            Bestätigen und weiter
          </Button>
        </Col>
        <Col sm="6" className="mt-3">
        {/* Abbrechen-Button */}
        {props.nextStep == null ? <ButtonAbbrechen/> : <></>}
        </Col>
        </Row>
      </Form>

    </div>
  );
}

//Schritt 8 Sendungsdaten eingeben (Maße, Gewicht): Idx 9
const StepSendungsdatenEingeben = () => {
  const {auftrag, setAuftrag} = useContext(AuftragContext);
  const navigate = useNavigate();
  //const btnFileUpload = React.useRef<HTMLInputElement>(null);
  const [maxLaenge, maxBreite, maxHoehe] = [399, 240, 300];
  const maxKg = 10000;
  const [fehlerAnzeigen, setFehlerAnzeigen] = useState(false);
  const [fehlerText, setFehlerText] = useState("");

  const weiter = () => {
    if(auftrag.sendung?.masse?.laenge == null || auftrag.sendung?.masse?.breite == null || auftrag.sendung?.masse?.hoehe == null){
      setFehlerText("Bitte gültige Maße eingeben!");
      setFehlerAnzeigen(true);
    } else if (parseInt(auftrag.sendung.kg ?? "0") <= 0) {
      setFehlerText("Bitte ein Gewicht eingeben!");
      setFehlerAnzeigen(true);
/*    } else if (auftrag.sendung.typbez == null) {
      setFehlerText("Bitte gültige Typenbezeichnung eingeben!");
      setFehlerAnzeigen(true);
*/
    } else {
      navigate("/steps/9");
    }
  }

  return (
    <div>
      <AlertDismissible header="Eingabefehler" msgtext={<>{fehlerText}</>} show={fehlerAnzeigen} setShow={setFehlerAnzeigen}/>
      <Row>
        <ImageStepCol img={abmessungen}/>
      </Row>    
      <Row className="mt-5">
        <Col>
          <HeaderStep text={["Informationen zum Bulldog:"]}/>
        </Col>
      </Row>
      <Row>
        <Col className="text-center fs-4 mb-md-3">
            Gleich geschafft! <br/>
            Bitte ergänzen Sie die folgenden Angaben:
        </Col>
      </Row>
      <Form>
      <Row>
          <Col sm="4">
            <EingabeMass beschriftung="Länge" max={maxLaenge} masseKey="laenge" disabled={(parseInt(auftrag.sendung?.masse?.laenge ?? "0")) > 400}/>
          </Col>
          <Col sm="4">
            <EingabeMass beschriftung="Breite" max={maxBreite} masseKey="breite" disabled={(parseInt(auftrag.sendung?.masse?.laenge ?? "0")) > 400}/>
          </Col>
          <Col sm="4">
            <EingabeMass beschriftung="Höhe" max={maxHoehe} masseKey="hoehe" disabled={(parseInt(auftrag.sendung?.masse?.laenge ?? "0")) > 400}/>
          </Col>
        </Row>
        <Row>
          <Col sm="4">
            <Form.Control value={auftrag.sendung?.kg ?? ''} type="number" className="mt-3" size="lg" placeholder="Gewicht in kg, max 10.000"
              onChange={ (e) => {const val = e.target.value; (val == "" || parseInt(val) <= maxKg) && setAuftrag({...auftrag, sendung: {...auftrag.sendung, kg: val == "" ? null : val}})} }/>
          </Col>
          <Col sm="4">
            <Form.Control value={auftrag.sendung?.typbez ?? ''} className="mt-3" size="lg" placeholder="Typbezeichnung"
              onChange={ (e) => {const val = e.target.value; setAuftrag({...auftrag, sendung: {...auftrag.sendung, typbez: val == "" ? null : val}})} }/>
          </Col>
        </Row>
 {/*
       <Row>
          <Col sm="12">
            <InputGroup className="mt-3">
              <InputGroup.Text className="upload-label fs-5" onClick={() => btnFileUpload.current?.click()} >Fahrzeugschein hochladen</InputGroup.Text>
              <Form.Control ref={btnFileUpload} id="btnUploadFahrzeugschein" className="upload-button" type="file" size="lg"/>
            </InputGroup>
          </Col>
        </Row>
        <Row>
          <Col sm="12">
            <InputGroup className="mt-3">
              <InputGroup.Text className="upload-label fs-5" onClick={() => btnFileUpload.current?.click()} >Fahrzeugbilder</InputGroup.Text>
              <Form.Control ref={btnFileUpload} id="btnUploadFahrzeugbilder" className="upload-button" type="file" size="lg"/>
            </InputGroup>
          </Col>
        </Row>
  */}
        <Row className="d-grid gap-2 mt- mt-5">
          <Button variant="primary" size="lg" onClick={weiter}>
            Eingaben bestätigen
          </Button>
        </Row>
      </Form>

    </div>
  );
}

//Schritt 9 Bestätigung: Idx 10
const StepBestaetigung = () => {
  const [istAGBAkzeptiert, setIstAGBAkzeptiert] = useState(false);
  //const [istTransportVersicherungGebucht, setIstTransportversicherungGebucht] = useState(false);
  const {auftrag, setAuftrag} = useContext(AuftragContext);
  const navigate = useNavigate();
  const [fehlerAnzeigen, setFehlerAnzeigen] = useState(false);
  const [fehlertext, setFehlertext] = useState(<></>);

  //Auftrag absenden/speichern
  const absenden = async () => {
    try {
      setAuftrag(await auftragAbsendenCoponent(auftrag, webserviceEnvironment));
      navigate("/steps/10");
    } catch (error) {
      if (typeof error == "string") {
        setFehlertext(<>{error}</>);
      } else {
        console.error(error);
        setFehlertext(<>Fehler beim Speichern des Auftrags!</>);
      }
      setFehlerAnzeigen(true);
    }
  }

  return (
    <div>
      <AlertDismissible header="Eingabefehler" msgtext={<>{fehlertext}</>} show={fehlerAnzeigen} setShow={setFehlerAnzeigen}/>
      <Row>
        <Col>
          <HeaderStep text={["Zusammenfassung:"]}/>
        </Col>
      </Row>
      <Row>
        <Col className="text-center fs-4 mb-md-3">
          Sie möchten folgenden Transport beauftragen:
        </Col>
      </Row>
      <Row className="fs-5 mb-md-3 mt-4 fw-bold">
        <Col sm="4">
          Zu transportieren:
        </Col>
        <Col sm="8">
          1x Bulldog {auftrag.sendung?.masse?.laenge} x {auftrag.sendung?.masse?.breite} x {auftrag.sendung?.masse?.hoehe} cm, {auftrag.sendung?.kg} kg
        </Col>
      </Row>
      <Row className="mt-3">
        <Col md={{span: 12, offset: 0}}>
          <Form.Check disabled={true} checked={auftrag.istFahrtuechtig} className="fs-4" type="switch" id="custom-switch" label="Bulldog ist fahrtüchtig"/>
        </Col>
      </Row>
      <Row className="fs-5 mb-md-3 mt-4">
        <Col sm="4">
          Gesamtpreis:
        </Col>
        <Col sm="8">
        {libInEuroAnzeigen(auftrag.letzterPreis?.gesamt?.wert ?? 0)}
        </Col>
      </Row>
      <Row className="fs-5 mb-md-3 mt-4">
        <Col sm="4">
          MwSt.:
        </Col>
        <Col sm="8">
        {libInEuroAnzeigen((auftrag.letzterPreis?.ust?.wert ?? 0))}
        </Col>
      </Row>
      <Row className="fs-5 mb-md-3 mt-4 fw-bold">
        <Col sm="4">
          Gesamtpreis inkl. MwSt.:
        </Col>
        <Col sm="8">
        {libInEuroAnzeigen(auftrag.letzterPreis?.gesamtUst?.wert ?? 0)}
        </Col>
      </Row>
      <Row className="mt-4">
        <AdresseBestaetigung art="Frachtzahler" firma={auftrag.fz.firma} name1={auftrag.fz.name} str={auftrag.fz.str} plz={auftrag.fz.plz} ort={auftrag.fz.ort} tel={auftrag.fz.tel} email={auftrag.fz.email} editStep="/steps/11"/>
      </Row>
      <Row>
      <AdresseBestaetigung art="Versender" firma={auftrag.lad.firma} name1={auftrag.lad.name} str={auftrag.lad.str} plz={auftrag.lad.plz} ort={auftrag.lad.ort} tel={auftrag.lad.tel} email={auftrag.lad.email} editStep="/steps/12"/>
      </Row>
      <Row>
      <AdresseBestaetigung art="Empfänger" firma={auftrag.elad.firma} name1={auftrag.elad.name} str={auftrag.elad.str} plz={auftrag.elad.plz} ort={auftrag.elad.ort} tel={auftrag.elad.tel} email={auftrag.elad.email} editStep="/steps/13"/>
      </Row>
      <Form>
        <Row className="mt-3">
          <Col md={{span: 12, offset: 0}}>
              <Form.Check disabled={true} checked={(auftrag.sendung?.warenwert ?? null) !== null} className="fs-4" type="switch" id="cb-tv-bestaetigung" label="Transportversicherung gebucht"/>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md={{span: 12, offset: 0}}>
              <Form.Check checked={istAGBAkzeptiert} onChange={(e) => setIstAGBAkzeptiert(e.currentTarget.checked)} className="fs-4" type="switch" id="cb-agbs" label={<><a href="/FILES/agbs.pdf" target="_blank">AGBs</a> akzeptieren</>}/>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col sm="6" className="mt-3">
            <Button disabled={!istAGBAkzeptiert} variant="primary" size="lg" className="w-100" onClick={absenden}>
              Verbindlich buchen
            </Button>
          </Col>
          <Col sm="6" className="mt-3">
          {/* Abbrechen-Button */}
          <ButtonAbbrechen/>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col className="text-center fs-9 mb-md-3">
              Sie haben Fragen und möchten direkt Kontakt aufnehmen? <br/>
              Melden Sie sich gerne per E-Mail unter <a href="mailTo:jumbodispo@ruedinger.de">jumbodispo@ruedinger.de</a> oder telefonisch: 06294/908-32
          </Col>
        </Row>
      </Form>

    </div>
  );
}
//AdresseBestaetigung
const AdresseBestaetigung = (props: {art: string, firma : string|null, name1 : string|null, str : string|null, plz : string|null, ort: string|null, tel ?: string|null, email: string|null,  editStep: string}) => {
  const navigate = useNavigate();
  console.log("TEL:");
  console.log(props.tel);
  return(
    <>
    <Col sm="4">
      <div className="fs-5 mb-md-3 fw-bold">
        <Image role="button" src={bearbeiten} width={25} className="me-3" onClick={ () => navigate(props.editStep)}/>
        {props.art}:
      </div>
    </Col>
    <Col>
      <div className="fs-5 mb-md-3">
        {props.firma !== null && props.firma.length > 0 ? props.firma + ', ' : ""}{props.name1}, {props.str}, {props.plz} {props.ort} <br/>
        {props.tel != null && '📞 ' + props.tel} <br/>
        {props.email != null && '📧 ' + props.email}
        
      </div>
    </Col>
    </>
  )

}

//Schritt 10 Bezahlung: Idx 11
const StepBezahlung = () => {
  const {auftrag, setAuftrag} = useContext(AuftragContext);

  return (
    <div>
      <Row>
        <ImageStepCol img={buchungsbestaetigung}/>
      </Row>
      <Row className='mt-5'>
        <Col>
          <HeaderStep text={["Vielen Dank für Ihren Transportauftrag!"]}/>
        </Col>
      </Row>
      <Row>
        <Col className="text-center fs-4 mb-md-3">
            In Kürze erhalten Sie Ihre Auftragszusammenfassung per E-Mail an:<br/>
            <strong>{auftrag.fz.email}</strong>
        </Col>
      <Row>
        <Col className="text-center fs-4 mb-md-3 mt-4">
          Bitte überweisen Sie <strong>{libInEuroAnzeigen(auftrag.letzterPreis?.gesamtUst?.wert ?? 0)}</strong> an folgendes Konto:<br/>
            BW Bank Heilbronn <br/> Kontoinhaber: Rüdinger Spedition GmbH <br/> IBAN: DE15 6005 0101 0004 1117 13 <br/>
            Verwendungszweck: <strong>{auftrag.referenz}</strong><br/><br/>
          Nach Geldeingang der Transportkosten in Höhe von <strong>{libInEuroAnzeigen (auftrag.letzterPreis?.gesamtUst?.wert ?? 0)}</strong>, planen wir den Transport ein. <br/>
          Sie erhalten dann eine schriftliche Auftragsbestätigung an {auftrag.fz.email}. <br/>
        </Col>
      </Row>
      </Row>
        </div>
  );
}

export default Navigator;